import React from 'react'
import IndicatorCustomer from './IndicatorCustomer'
import { needTotalEnum, IndicatorFilter, IndicatorDataType } from '@types'
import { Indicator } from '.'
import IndicatorLead from './IndicatorLead'

export default function IndicatorList ({ pane, filter }: { pane: Indicator, filter: IndicatorFilter }) {
  if (pane?.dataType === IndicatorDataType.Lead) {
    return <IndicatorLead pane={pane} initFilter={{ ...filter, tag: pane.tag, page: 1, pageSize: 10, needTotal: needTotalEnum.LIST }} filterKey={pane?.filterKey} />
  }
  return <IndicatorCustomer initFilter={{ ...filter, tag: pane.tag, page: 1, pageSize: 10, needTotal: needTotalEnum.LIST }} filterKey={pane?.filterKey} />
}
